import { cva } from 'class-variance-authority';

export const ImageWrapperStyles = cva('block overflow-hidden', {
  variants: {
    fill: {
      true: 'absolute inset-0',
      false: 'relative w-full',
    },
    placeholder: {
      true: 'shimmer-base',
    },
    animatePlaceholder: {
      true: 'shimmer-animate',
    },
    isLoaded: {
      true: 'shimmer-fadeout',
    },
  },

  defaultVariants: {
    fill: false,
    placeholder: false,
    animatePlaceholder: false,
    isLoaded: false,
  },
});

export const ImageStyles = cva(
  'transition-image absolute inset-0 size-full select-none',
  {
    variants: {
      fade: {
        true: 'opacity-0',
        false: '',
      },
      hoverEffect: {
        zoom: 'group-hover:scale-105',
      },
      objectFit: {
        cover: 'object-cover',
        contain: 'object-contain',
      },
      objectPosition: {
        center: 'object-center',
        top: 'object-top',
        bottom: 'object-bottom',
        left: 'object-left',
        right: 'object-right',
      },
    },
    defaultVariants: {
      fade: true,
      objectFit: 'cover',
      objectPosition: 'center',
    },
  }
);
